import { c as _c } from "react/compiler-runtime";
import { Lineicons } from '@lineiconshq/react-lineicons';
import favicon from '../../app/favicon.svg';
import { ChevronLeftCircleOutlined, ArrowLeftOutlined, ArrowRightOutlined, ArrowDownwardOutlined, ArrowAngularTopRightOutlined, QuestionMarkCircleOutlined, Bulb4Outlined, RefreshCircle1ClockwiseOutlined, CheckCircle1Outlined, XmarkCircleOutlined, VolumeHighOutlined, VolumeLowOutlined, PlayOutlined, PauseSolid } from '@lineiconshq/free-icons';
type IconProps = {
  name: string;
  color: string;
  size?: number;
  className?: string;
};
const Icon = t0 => {
  const $ = _c(60);
  const {
    name,
    color,
    size,
    className
  } = t0;
  switch (name) {
    case "chevron-left-rounded":
      {
        let t1;
        if ($[0] !== className || $[1] !== color || $[2] !== size) {
          t1 = <Lineicons icon={ChevronLeftCircleOutlined} color={color} size={size} className={className} />;
          $[0] = className;
          $[1] = color;
          $[2] = size;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "arrow-left":
      {
        let t1;
        if ($[4] !== className || $[5] !== color || $[6] !== size) {
          t1 = <Lineicons icon={ArrowLeftOutlined} color={color} size={size} className={className} />;
          $[4] = className;
          $[5] = color;
          $[6] = size;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "arrow-right":
      {
        let t1;
        if ($[8] !== className || $[9] !== color || $[10] !== size) {
          t1 = <Lineicons icon={ArrowRightOutlined} color={color} size={size} className={className} />;
          $[8] = className;
          $[9] = color;
          $[10] = size;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case "arrow-down":
      {
        let t1;
        if ($[12] !== className || $[13] !== color || $[14] !== size) {
          t1 = <Lineicons icon={ArrowDownwardOutlined} color={color} size={size} className={className} />;
          $[12] = className;
          $[13] = color;
          $[14] = size;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case "arrow-diagonal":
      {
        let t1;
        if ($[16] !== className || $[17] !== color || $[18] !== size) {
          t1 = <Lineicons icon={ArrowAngularTopRightOutlined} color={color} size={size} className={className} />;
          $[16] = className;
          $[17] = color;
          $[18] = size;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case "question-mark":
      {
        let t1;
        if ($[20] !== className || $[21] !== color || $[22] !== size) {
          t1 = <Lineicons icon={QuestionMarkCircleOutlined} color={color} size={size} className={className} />;
          $[20] = className;
          $[21] = color;
          $[22] = size;
          $[23] = t1;
        } else {
          t1 = $[23];
        }
        return t1;
      }
    case "bulb":
      {
        let t1;
        if ($[24] !== className || $[25] !== color || $[26] !== size) {
          t1 = <Lineicons icon={Bulb4Outlined} color={color} size={size} className={className} />;
          $[24] = className;
          $[25] = color;
          $[26] = size;
          $[27] = t1;
        } else {
          t1 = $[27];
        }
        return t1;
      }
    case "refresh":
      {
        let t1;
        if ($[28] !== className || $[29] !== color || $[30] !== size) {
          t1 = <Lineicons icon={RefreshCircle1ClockwiseOutlined} color={color} size={size} className={className} />;
          $[28] = className;
          $[29] = color;
          $[30] = size;
          $[31] = t1;
        } else {
          t1 = $[31];
        }
        return t1;
      }
    case "check":
      {
        let t1;
        if ($[32] !== className || $[33] !== color || $[34] !== size) {
          t1 = <Lineicons icon={CheckCircle1Outlined} color={color} size={size} className={className} />;
          $[32] = className;
          $[33] = color;
          $[34] = size;
          $[35] = t1;
        } else {
          t1 = $[35];
        }
        return t1;
      }
    case "cancel":
      {
        let t1;
        if ($[36] !== className || $[37] !== color || $[38] !== size) {
          t1 = <Lineicons icon={XmarkCircleOutlined} color={color} size={size} className={className} />;
          $[36] = className;
          $[37] = color;
          $[38] = size;
          $[39] = t1;
        } else {
          t1 = $[39];
        }
        return t1;
      }
    case "volume-high":
      {
        let t1;
        if ($[40] !== className || $[41] !== color || $[42] !== size) {
          t1 = <Lineicons icon={VolumeHighOutlined} color={color} size={size} className={className} />;
          $[40] = className;
          $[41] = color;
          $[42] = size;
          $[43] = t1;
        } else {
          t1 = $[43];
        }
        return t1;
      }
    case "volume-low":
      {
        let t1;
        if ($[44] !== className || $[45] !== color || $[46] !== size) {
          t1 = <Lineicons icon={VolumeLowOutlined} color={color} size={size} className={className} />;
          $[44] = className;
          $[45] = color;
          $[46] = size;
          $[47] = t1;
        } else {
          t1 = $[47];
        }
        return t1;
      }
    case "play":
      {
        let t1;
        if ($[48] !== className || $[49] !== color || $[50] !== size) {
          t1 = <Lineicons icon={PlayOutlined} color={color} size={size} className={className} />;
          $[48] = className;
          $[49] = color;
          $[50] = size;
          $[51] = t1;
        } else {
          t1 = $[51];
        }
        return t1;
      }
    case "pause":
      {
        let t1;
        if ($[52] !== className || $[53] !== color || $[54] !== size) {
          t1 = <Lineicons icon={PauseSolid} color={color} size={size} className={className} />;
          $[52] = className;
          $[53] = color;
          $[54] = size;
          $[55] = t1;
        } else {
          t1 = $[55];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[56] !== className || $[57] !== color || $[58] !== size) {
          t1 = <Lineicons icon={favicon} color={color} size={size} className={className} />;
          $[56] = className;
          $[57] = color;
          $[58] = size;
          $[59] = t1;
        } else {
          t1 = $[59];
        }
        return t1;
      }
  }
};
export { Icon };